import React from 'react';
import { bool } from 'prop-types';
import './alerts.scss';

export const Alerts = (props) => {
  const {
    jumpedState,
    impossibleState,
    unavailableState,
    isDiscontinued,
    isOutOfStock
  } = props;

  let alert;
  if (isDiscontinued) {
    alert = 'Discontinued';
  } else if (isOutOfStock) {
    alert = 'Out of Stock';
  } else if (unavailableState) {
    alert = 'Unavailable combination. Please make another selection.';
  }

  return (
    <>
      {(jumpedState || impossibleState)
        && (
          <div className="inline-alert alert-inline alert-inline--warning">
            <span className="alert-inline__message">
              <span className="alert-inline__title">
                {jumpedState && (
                  <div>
                    Your Selections have been updated based on availability
                  </div>
                )}

                {impossibleState && (
                  <div>
                    <span className="alert-inline__title">
                      We had some trouble loading your options.
                    </span>
                    <br />Select any option to get started.
                  </div>
                )}
              </span>
            </span>
          </div>
        )}
      {(unavailableState || isDiscontinued || isOutOfStock)
        && (
          <div className="inline-alert alert-inline alert-inline--danger">
            <span className="alert-inline__message">
              <div>{alert}</div>
            </span>
          </div>
        )}
    </>
  );
};

Alerts.displayName = 'SuperSkuAlerts';

Alerts.propTypes = {
  jumpedState: bool,
  impossibleState: bool,
  unavailableState: bool,
  isDiscontinued: bool,
  isOutOfStock: bool
};

Alerts.defaultProps = {
  jumpedState: false,
  impossibleState: false,
  unavailableState: false,
  isDiscontinued: false,
  isOutOfStock: false
};
